import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-84634c20")

_pushScopeId("data-v-84634c20")
const _hoisted_1 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_2 = {
  class: "flex-grow-1 card-p pb-0",
  style: {"background":"{{ background }}"}
}
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center justify-content-between" }
const _hoisted_4 = { class: "w-75" }
const _hoisted_5 = { class: "widget-content-area" }
const _hoisted_6 = { class: "text-muted fs-6 mb-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "icon-wrapper w-25 text-end" }
const _hoisted_9 = { class: "icon-holder" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card order-widget"]
  }, [
    (_ctx.loaderEnabled)
      ? (_openBlock(), _createBlock(_component_InnerLoader, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, {
                to: _ctx.link == '#' ? '' : _ctx.link,
                class: [_ctx.link == '#' ? 'pointer' : '', "widget-heading fw-bolder fs-3"]
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.title)), 1)
                ]),
                _: 1
              }, 8, ["to", "class"]),
              _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.titleDescription)), 1),
              _createVNode("div", {
                class: [`text-${_ctx.chartColor}`, "fw-bolder main-content"]
              }, [
                (!_ctx.getMillifyValue)
                  ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.getKey), 1))
                  : (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      class: "item",
                      effect: "dark",
                      content: _ctx.getKey,
                      placement: "top"
                    }, {
                      default: _withId(() => [
                        _createVNode("span", null, _toDisplayString(_ctx.getMillifyValue), 1)
                      ]),
                      _: 1
                    }, 8, ["content"]))
              ], 2)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("img", {
                src: _ctx.icon,
                alt: _ctx.title
              }, null, 8, ["src", "alt"])
            ]),
            (_ctx.link != '#')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: ["btn-link widget-heading", _ctx.link == '#' ? 'pointer' : ''],
                  to: _ctx.link
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("message.SEE_ALL")), 1)
                  ]),
                  _: 1
                }, 8, ["to", "class"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 2))
})